import { FormattedMessage } from 'react-intl'

import TextLink from 'LuxKit/TextLink'

import LoadingSpinner from 'components/Common/Loading/LoadingSpinner'
import useSimilarCruiseSearchUrl from 'hooks/Cruise/useSimilarCruiseSearchUrl'

interface Props {
  cabinType: string
  departure: App.CruiseDepartureDetails
  offer: App.CruiseOffer
}

function CruiseSimilarResultsLink({
  cabinType,
  departure,
  offer,
}: Props) {
  const similarCruiseSearchUrl = useSimilarCruiseSearchUrl({
    arrivalDate: departure.arrivalDate,
    cabinType,
    departureDate: departure.departureDate,
    offer,
  })

  return <TextLink
    disabled={similarCruiseSearchUrl.isResolving}
    onClick={similarCruiseSearchUrl.navigateToSimilarCruises}
    size="small"
    startIcon={similarCruiseSearchUrl.isResolving ? <LoadingSpinner inline size={12} /> : undefined}
    weight="regular"
  >
    <FormattedMessage
      id="09CgHmgWuqx8RQ0tJLqw"
      defaultMessage="View similar cruises"
      description="Secondary action link text for sold out error in the cruises section"
    />
  </TextLink>
}

export default CruiseSimilarResultsLink
